import { createContext, useContext, useState, useMemo } from 'react';
import PropTypes from 'prop-types';

const VhostFindingsCountContext = createContext({
  count: 0,
  setCount: () => {},
});

export function VhostFindingsCountProvider({ children }) {
  const [count, setCount] = useState(0);

  const value = useMemo(() => ({
    count,
    setCount,
  }), [count]);

  return (
    <VhostFindingsCountContext.Provider value={value}>
      {children}
    </VhostFindingsCountContext.Provider>
  );
}

VhostFindingsCountProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useVhostFindingsCount = () => useContext(VhostFindingsCountContext); 